module.exports = __webpack_public_path__ + "static/media/food.9558a108.jpg";